/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Inventory trade request
 */
export interface InventoryTradeRequest {
  /**
   * Pair IDs for execution. Only LP pairs with same basePairId allowed.
   */
  pairIds: Array<number>;
  /**
   * Trade direction.
   */
  side: InventoryTradeRequest.SideEnum;
  /**
   * Qty for client(in base asset).
   */
  units: number;
}
export namespace InventoryTradeRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
